import css from "../../css/listing/snapshot.module.css";

import React from "react";
import PropTypes from "prop-types";

const Row = (props) => {
    return (
        <>
            {props.value !== null && (
                <div className={css.row}>
                    <div
                        className={css.column}
                        style={props.label2 ? {} : { width: "100%" }}
                    >
                        <div className={css.label}>{props.label}</div>
                        <div className={css.value}>{props.value}</div>
                    </div>
                    {props.label2 && (
                        <div className={css.column}>
                            <div className={css.label}>{props.label2}</div>
                            <div className={css.value}>{props.value2}</div>
                        </div>
                    )}
                </div>
            )}
        </>
    );
};

Row.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.any,
    label2: PropTypes.string,
    value2: PropTypes.any,
};

Row.defaultProps = {
    value: null,
    label2: null,
    value2: null,
};

export default Row;
